import { render, staticRenderFns } from "./HowItWorksItem.vue?vue&type=template&id=7287bca0&scoped=true"
import script from "./HowItWorksItem.vue?vue&type=script&lang=js"
export * from "./HowItWorksItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7287bca0",
  null
  
)

export default component.exports